module.exports = __webpack_public_path__ + "img/rmz-historia-m.0188aed2.png";